import { cn } from "@/utils/css";

export const FilterButton = ({ onClick, active, disabled = false, children }) => {
    return (
        <button
            disabled={disabled}
            className={cn(
                "h-[34px] text-cm-p-text-primary border rounded-[58px] border-cm-p-surface-container bg-cm-p-surface-container text-sm/[22px] font-medium py-1 px-3 flex-1",
                {
                    "text-cm-p-on-container-green bg-cm-p-container-green border-cm-p-accent": active,
                    "opacity-40 cursor-not-allowed": disabled,
                },
            )}
            onClick={onClick}
            type="button"
        >
            {children}
        </button>
    );
};
